import { TypedDocumentNode, gql } from '@apollo/client';
import { useCallback } from 'react';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useConfigContext } from '@sorare/core/src/contexts/config';

import { useTokenTakesPartPromotionalEvent_anyCard } from './__generated__/useTokenTakesPartPromotionalEvent.graphql';

type MarketplacePromotionalEvent = {
  slugs: string[];
  rewardDetailsHref: string | null;
  name: string;
};

const getTokenEvent = (
  token: { slug: string; sport: Sport } | undefined | null,
  promotionalEvents: {
    sport: Sport;
    events: MarketplacePromotionalEvent[];
  }[]
) => {
  if (!token) return undefined;

  const { sport, slug } = token;

  const sportEvents = promotionalEvents.find(
    event => event.sport === sport
  )?.events;

  return sportEvents?.find(
    event => event.rewardDetailsHref && event.slugs.includes(slug)
  );
};

export const useTokenTakesPartPromotionalEvent = () => {
  const { marketplacePromotionalEvents } = useConfigContext();

  return useCallback(
    (
      cards: useTokenTakesPartPromotionalEvent_anyCard[]
    ): MarketplacePromotionalEvent | undefined => {
      const tokenEvents = cards.map(card =>
        getTokenEvent(card, marketplacePromotionalEvents)
      );

      return tokenEvents.find(event => event);
    },
    [marketplacePromotionalEvents]
  );
};

useTokenTakesPartPromotionalEvent.fragments = {
  anyCard: gql`
    fragment useTokenTakesPartPromotionalEvent_anyCard on AnyCardInterface {
      sport
      slug
    }
  ` as TypedDocumentNode<useTokenTakesPartPromotionalEvent_anyCard>,
};
